function getUrl(baseUrl, url) {
	const re = /^(http|https):\/\//i;
	if (re.test(url)) {
		return url;
	}
	return baseUrl + url;
}

function parseResponseData(responseText) {
	if (!responseText) {
		return {};
	}
	try {
		return JSON.parse(responseText);
	} catch {
		return { error: responseText };
	}
}

function decorateError(error, xhr) {
	const decoratedError = error;
	const status = xhr?.status ?? 0;
	const responseText = xhr?.responseText;
	const parsedData = parseResponseData(responseText);
	decoratedError.response = {
		status,
		data: {
			...parsedData,
			reason: parsedData.reason || responseText,
			message: parsedData.message || error.message
		}
	};

	// Attach the XHR object so traceparent and other response headers are accessible
	if (xhr) {
		decoratedError.request = xhr;
	}

	return decoratedError;
}

export default class Http {
	constructor(apiUrl, getAuthToken) {
		this._getAuthToken = getAuthToken;
		this._apiUrl = apiUrl;
	}

	get(url, cancellationToken) {
		return new Promise((resolve, reject) => {
			const req = new XMLHttpRequest();
			req.open("GET", getUrl(this._apiUrl, url));
			req.setRequestHeader("Authorization", this._getAuthToken());
			req.setRequestHeader("Cache-Control", "no-cache, no-store, must-revalidate");
			req.setRequestHeader("Pragma", "no-cache");
			req.onload = function onLoad() {
				if (req.status >= 200 && req.status <= 299) {
					resolve(req.response);
				} else {
					reject(decorateError(new Error(req.statusText), req));
				}
			};

			if (cancellationToken) {
				cancellationToken.cancel = function cancel() { // eslint-disable-line no-param-reassign
					req.abort();
				};
			}

			req.onerror = function onError() {
				reject(decorateError(new Error("Network error"), req));
			};

			req.send();
		});
	}
}
